module.exports = __webpack_public_path__ + "static/media/appgallery.7a0240c7.png";